"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPercentToDecimal = exports.formatDecimalToPercent = exports.formatWithPrecision = exports.formatWithThousandSeparator = exports.round = void 0;
exports.approximatedNumberString = approximatedNumberString;
function approximatedNumberString(num, digits = 0, units = ["k", "M", "G", "T", "P", "E"]) {
    if (num === 0) {
        return "0";
    }
    if (num < 1000) {
        return num.toFixed(digits).toString();
    }
    let i = Math.floor(Math.log10(num) / Math.log10(1000));
    if (i >= units.length) {
        i = units.length - 1;
    }
    return (num / Math.pow(10, 3 * i)).toFixed(digits).toString() + units[i - 1];
}
const round = (number, precision) => {
    if (precision) {
        precision = precision >= 0 ? Math.min(precision, 292) : Math.max(precision, -292);
        // Shift with exponential notation to avoid floating-point issues.
        // See [MDN](https://mdn.io/round#Examples) for more details.
        let pair = `${number}e`.split("e");
        const value = Math.round(+`${pair[0]}e${+pair[1] + precision}`);
        pair = `${value}e`.split("e");
        return +`${pair[0]}e${+pair[1] - precision}`;
    }
    return Math.round(number);
};
exports.round = round;
const separate = (number) => {
    const result = [];
    let i = number.length - 1;
    let j = 0;
    while (i >= 0) {
        result.push(number[i]);
        if (j === 2 && i > 0) {
            result.push(" ");
        }
        j = (j + 1) % 3;
        i--;
    }
    return result;
};
const formatWithThousandSeparator = (number) => {
    const [int, frac] = number.toString().split(".");
    return separate(int).reverse().join("") + (frac ? `.${frac}` : "");
};
exports.formatWithThousandSeparator = formatWithThousandSeparator;
const formatWithPrecision = (number, precision) => {
    const [int, frac = ""] = (0, exports.round)(number, precision).toString().split(".");
    return separate(int).reverse().join("") + (precision ? "." + frac.padEnd(precision, "0") : "");
};
exports.formatWithPrecision = formatWithPrecision;
// Multiplication by 100 may lead to weird results like 0.14 * 100 == 14.000000000000002.
// As a workaround simple string operation instead of math is used for this conversion.
const formatDecimalToPercent = (val, precision) => {
    if (!val) {
        return 0;
    }
    const isNegative = val < 0;
    const absoluteVal = Math.abs(val);
    const [int, frac = ""] = String(absoluteVal).split(".");
    const paddedFrac = frac.padEnd(3, "0");
    const parsedVal = parseFloat(`${int}${paddedFrac.slice(0, 2)}.${paddedFrac.slice(2)}`);
    const result = precision ? (0, exports.round)(parsedVal, precision) : parsedVal;
    return isNegative ? -result : result;
};
exports.formatDecimalToPercent = formatDecimalToPercent;
// Dividing by 100 may lead to weird results like 1.4 / 100 == 0.013999999999999999.
// As a workaround simple string operation instead of math is used for this conversion.
const formatPercentToDecimal = (val, precision) => {
    if (!val) {
        return 0;
    }
    const isNegative = val < 0;
    const absoluteVal = Math.abs(val);
    const [int, frac = ""] = String(absoluteVal).split(".");
    const paddedInt = int.padStart(3, "0");
    const parsedVal = parseFloat(`${paddedInt.slice(0, -2)}.${paddedInt.slice(-2)}${frac}`);
    const result = precision ? (0, exports.round)(parsedVal, precision) : parsedVal;
    return isNegative ? -result : result;
};
exports.formatPercentToDecimal = formatPercentToDecimal;
//# sourceMappingURL=num.js.map